/**
 * File-related utility functions for chat drafts.
 */
import {ChatFileUpload, ChatSelectedFile} from './ChatLibraryTypes';

/**
 * Get completed file uploads from selected files.
 */
export function getCompletedUploads(selectedFiles: Array<ChatSelectedFile>): Array<ChatFileUpload> {
  return selectedFiles.filter((f) => f.completedUpload != null).map((f) => f.completedUpload!);
}

/**
 * Check if there are any files still uploading.
 */
export function hasUploadingFiles(selectedFiles: Array<ChatSelectedFile>): boolean {
  return selectedFiles.some((f) => f.completedUpload == null);
}

/**
 * Get completed file uploads ready for submission.
 * @throws if there are files still uploading
 */
export function getFileUploadsForSubmission(selectedFiles: Array<ChatSelectedFile>): Array<ChatFileUpload> {
  if (hasUploadingFiles(selectedFiles)) {
    throw new Error('Cannot get file uploads while files are still uploading');
  }
  return getCompletedUploads(selectedFiles);
}
